import React from 'react';
import { Badge, Box, Tooltip } from '@chakra-ui/react';
import moment from 'moment';

import { 
  TableColumn, 
} from '@app/components/common/table';
import { Transaction } from '@app/api/models/transaction';
import { Equipment, MasterOutlet } from '@app/api/models';
import { Txt } from '@app/components/common';
import { USER_DATE_FORMAT, USER_DATE_TIME_FORMAT } from '@app/utils';

import { Status } from '../../transactions/components/status';
import { TxTypeView } from '../../transactions/components/tx-type';

// eslint-disable-next-line import/no-anonymous-default-export
export const useColumns = (): TableColumn<Transaction>[] => {
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: false,
        sort: false,
      }
    },
    {
      name: 'package_id',
      label: 'package',
      options: {
        hidden: true,
        group: {
          rowRender: (group, column, rowsData) => {
            switch(column.name) {
              case 'id': return <Badge>Пакет</Badge>;
              case 'type': return <TxTypeView type={rowsData[0].type} />;
              case 'status': return <Status status={rowsData[0].status} />;
              case 'create_dt': return <>{moment(rowsData[0].create_dt).format(USER_DATE_FORMAT)}</>;
              case 'equip': return <Box display='flex' alignItems='center' gap={2}>{rowsData.length} <Txt fontSize={12} color='gray.500'>транз-ций</Txt></Box>;
              case 'user': return <Box display='flex' alignItems='center'>{rowsData[0].user?.full_name}</Box>;
            }
            return <></>;
          },
        },
        customBodyRender: (value, rowsData) => {
          return <>package</>;
        }
      }
    },
    {
      name: 'type',
      label: 'Тип',
      options: {
        filter: {
          name: 'type_id',
          type: 'select',
          sourceName: 'transaction_type',
        },
        sort: true,
        customBodyRender: (value) => {
          return <TxTypeView type={value} />;
        }
      }
    },
    {
      name: 'status',
      label: 'Статус',
      options: {
        filter: {
          name: 'status_id',
          type: 'select',
          sourceName: 'transaction_status',
        },
        sort: true,
        customBodyRender: (value) => {
          return <Status status={value} />;
        }
      }
    },
    {
      name: 'transfer_dt',
      label: 'Дата перемещения',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: string) => {

          return <>{moment(value).format(USER_DATE_TIME_FORMAT)}</>;
        }
      }
    },
    {
      name: 'equip',
      label: 'ХО',
      options: {
        customBodyRender: (value: Equipment | null, { rowData }) => {
          if (!value) {return <Txt fontSize='sm' textColor='gray.500'>{rowData.transaction_model?.name || 'не определен'}</Txt>;}
          return <Box>
            <Txt textColor='brand-500'>{value.model?.name}</Txt>
            <Box display='flex' gap={2} fontSize='small' textColor='var(--chakra-colors-gray-500)'>
              <Txt fontSize='small'>{value.inventory_num}</Txt>
              <Box display='flex'>
                <Txt textColor='var(--chakra-colors-gray-700)'>SN: </Txt>
                <Txt>{value.serial_num}</Txt>
              </Box>
            </Box>
          </Box>;
        }
      }
    },
    {
      name: 'outlet_from',
      label: 'Из TT',
      options: {
        customBodyRender: (value: MasterOutlet | null) => {
          if (!value) {
            return <Txt textColor='var(--chakra-colors-gray-400)'>(пусто)</Txt>;
          }
          return <Box>
            <Txt textColor='brand-500'>{value?.legal_name}</Txt>
            <Box display='flex' gap={2} fontSize='small' textColor='var(--chakra-colors-gray-500)'>
              <Tooltip label={value?.full_address || value?.address?.full_address || ''}>
                <Box display='flex'>
                  <Txt>{value?.full_address || value?.address?.full_address.slice(0, 18)}...</Txt>
                </Box>
              </Tooltip>
            </Box>
          </Box>;
        }
      }
    },
    {
      name: 'outlet_to',
      label: 'В TT',
      options: {
        customBodyRender: (value: MasterOutlet | null) => {
          if (!value) {
            return <Txt textColor='var(--chakra-colors-gray-400)'>(пусто)</Txt>;
          }
          return <Box>
          <Txt textColor='brand-500'>{value?.legal_name}</Txt>
            <Box display='flex' gap={2} fontSize='small' textColor='var(--chakra-colors-gray-500)'>
              <Tooltip label={value?.full_address || value?.address?.full_address || ''}>
                <Box display='flex'>
                  <Txt>{value?.full_address || value?.address?.full_address.slice(0, 18)}...</Txt>
                </Box>
              </Tooltip>
            </Box>
          </Box>;
        }
      }
    },
    {
      name: 'distributor',
      label: 'Дистрибьютор',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (distributor, { rowData }) => {
          if (!distributor) {
            return <Txt textColor='var(--chakra-colors-gray-400)'>(пусто)</Txt>;
          }
          return <Box>
            <Txt textColor='brand-500'>{distributor?.name}</Txt>
          </Box>;
        }
      }
    },
    {
      name: 'user',
      label: 'Инициатор',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (user, { rowData }) => {
          if(!user?.full_name) {return <Txt color='gray.400'>(пусто)</Txt>;}
          return <>{user?.full_name}</>;
        }
      }
    },
    {
      name: 'outlet_to',
      label: 'Торговая точка назначения',
      options: {
        hidden: true,
        filter: {
          type: 'outlet',
          name: 'id_to',
        },
      },
    },
    {
      name: 'outlet_from',
      label: 'Торговая точка отправки',
      options: {
        hidden: true,
        filter: {
          type: 'outlet',
          name: 'id_from',
        },
      },
    },
    {
      name: 'distributor',
      label: 'Дистрибьютор',
      options: {
        hidden: true,
        filter: {
          type: 'autocomplete',
          name: 'distributor_id',
          sourceName: 'distributor',
        },
      },
    },
    {
      name: 'create_dt',
      label: 'Дата создания',
      options: {
        hidden: true,
        filter: {
          name: 'create_date_range',
          type: 'date-range',
          onApply: (value) => {
            return value.map((date) => date.split('T')[0]);
          }
        },
      },
    },
    {
      name: 'update_dt',
      label: 'Дата изменения',
      options: {
        hidden: true,
        filter: {
          name: 'update_date_range',
          type: 'date-range',
          onApply: (value) => {
            return value.map((date) => date.split('T')[0]);
          }
        },
      },
    },
  ];
};